import { createContext } from 'react';
import { Account } from 'api/account';

export const AccountContext = createContext<Account | undefined>(undefined);
